import Vue from 'vue'
import VueI18n from 'vue-i18n'
import localeEN from './locale/locale-en.js'
import localeES from './locale/locale-es.js'
import localePT from './locale/locale-pt.js'
import localeFR from './locale/locale-fr.js'
import localeDE from './locale/locale-de.js'

Vue.use(VueI18n)

const messages = {
  en: localeEN,
  es: localeES,
  pt: localePT,
  fr: localeFR,
  de: localeDE
}

const language =
  (window && window.navigator && window.navigator.language && window.navigator.language.search('-') > 0)
    ? window.navigator.language.split('-')[0]
    : window.navigator.language

const i18n = new VueI18n({
  locale: language, // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/plugins/i18n.js